import type { Getter, Setter } from 'jotai';
import type { UndoRedoActionCommand } from '../../../../../modernization-common/undo-redo/types';
import { setQuestionAnswerInSegments } from '../../../studio-store/utils/dynamic-answer-utils';
import { annotationMetadataAtom } from '../../annotation-atoms';
import type { UpdateAnnotationAttributeEventPayload } from '../events';
import { reviseDynamicAnswers } from './dynamic-answers-mutation';
export const updateAnnotationAttributeCommandFactory = (get: Getter, set: Setter): UndoRedoActionCommand<UpdateAnnotationAttributeEventPayload, void> => {
  let restoreDynamicAnswers: () => void = () => {};
  return {
    execute: payload => {
      const {
        annotationId,
        questionId,
        answer,
        frameSpan
      } = payload;
      const metadata = get(annotationMetadataAtom).get(annotationId);
      restoreDynamicAnswers = reviseDynamicAnswers(set, annotationId, metadata?.dynamicAnswers, current => setQuestionAnswerInSegments(current, questionId, answer, frameSpan));
    },
    undo: () => {
      restoreDynamicAnswers();
    }
  };
};